// Material
import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
	overrides: {
		MuiCssBaseline: {
			"@global": {
				html: {
					WebkitFontSmoothing: "auto",
				},
				a: {
					textDecoration: "none",
					color: "#131415",
				},
				"a-webkit-any-link": {
					textDecoration: "none",
					color: "#131415",
				},
			},
		},
		MuiButton: {
			root: {
				fontSize: "16px !important",
				borderRadius: "10px",
				textTransform: "none",
				padding: "6.5px 40px",
				boxShadow: "none",
			},
			outlined: {
				padding: "6.5px 40px",
			},
			contained: {
				boxShadow: "none",
			},
		},
	},
	palette: {
		primary: {
			main: "#FF9344",
			light: "#F9D7C0",
		},
		secondary: {
			main: "#4081FF",
			light: "#D6E5FC",
		},
		success: {
			main: "#00C853",
			light: "#D4FCD4",
		},
		common: {
			grey: "#E5E5E5",
			white: "#FFFFFF",
		},
		text: {
			primary: "#000000",
			secondary: "#F16621",
			disabled: "#ADADAD",
		},
	},
	shape: {
		borderRadius: "15px",
	},
	typography: {
		fontFamily: "Montserrat",
		fontStyle: "normal",
		fontSize: 16,
		fontWeightLight: 300,
		fontWeightRegular: 400,
		fontWeightMedium: 500,
		fontWeightBold: 600,
		fontWeightHeavy: 900,
		h1: {
			fontWeight: 600,
			fontSize: "22px",
			lineHeight: "auto",
		},
		h2: {
			fontWeight: 600,
			fontSize: "16px",
			lineHeight: "auto",
		},
		h3: {
			fontWeight: 400,
			fontSize: "16px",
			lineHeight: "auto",
		},
		h4: {
			fontSize: "14px",
			fontWeight: 500,
			lineHeight: "auto",
		},
		h6: {
			fontSize: "12px",
			fontWeight: 500,
		},
		subtitle1: {
			fontWeight: 400,
			fontSize: "12px",
			lineHeight: "auto",
		},
		subtitle2: {
			fontWeight: 400,
			fontSize: "10px",
			lineHeight: "auto",
		},
		subtitle3: {
			fontWeight: 400,
			fontSize: "13px",
			lineHeight: "auto",
		},
		button: {
			fontSize: "14px",
			fontWeight: 500,
		},
	},
});

export default theme;
